document.addEventListener("DOMContentLoaded", function () {
  console.log("Wishlist script loaded...");

  const wishlistIcon = document.querySelector(".wishlist-link");
  const wishlistCount = document.querySelector(".wishlist-counter");

  // Retrieve wishlist from localStorage
  function getWishlist() {
    return JSON.parse(localStorage.getItem("wishlist")) || [];
  }

  // Save wishlist to localStorage
  function saveWishlist(wishlist) {
    localStorage.setItem("wishlist", JSON.stringify(wishlist));
  }

  // Update wishlist count in navigation
  function updateWishlistCount() {
    const wishlist = getWishlist();
    wishlistCount.textContent = wishlist.length;
  }

  // Show notification popup
  function showNotification(message, linkText, linkUrl) {
    const notification = document.createElement("div");
    notification.style.position = "fixed";
    notification.style.top = "20px";
    notification.style.right = "20px";
    notification.style.background = "rgba(0, 0, 0, 0.8)";
    notification.style.color = "#fff";
    notification.style.padding = "15px 20px";
    notification.style.borderRadius = "5px";
    notification.style.boxShadow = "0 2px 6px rgba(0,0,0,0.3)";
    notification.style.zIndex = "1000";
    notification.style.fontFamily = "sans-serif";
    notification.style.display = "flex";
    notification.style.alignItems = "center";
    notification.style.gap = "10px";
    notification.innerHTML = `${message} <a href="${linkUrl}" style="color:#fff; text-decoration:underline;">${linkText}</a>`;

    document.body.appendChild(notification);
    setTimeout(() => {
      notification.remove();
    }, 3000);
  }

  // Toggle product in wishlist
  function toggleWishlist(productHandle, iconElement) {
    let wishlist = getWishlist();
    const icon = iconElement.querySelector("svg");

    if (wishlist.includes(productHandle)) {
      wishlist = wishlist.filter((handle) => handle !== productHandle);
      icon.style.fill = "white";
      iconElement.setAttribute("title", "Add to Wishlist");
      showNotification("Product removed from wishlist.", "View Wishlist", "/pages/wishlist");
    } else {
      wishlist.push(productHandle);
      icon.style.fill = "black";
      iconElement.setAttribute("title", "Remove from Wishlist");
      showNotification("Product added to wishlist.", "View Wishlist", "/pages/wishlist");
    }

    saveWishlist(wishlist);
    updateWishlistCount();
  }
  document.querySelectorAll(".wishlist-icon1").forEach((iconElement) => {
    const productHandle = iconElement.dataset.productHandle;
    const wishlist = getWishlist();
    const icon = iconElement.querySelector("svg");

    if (wishlist.includes(productHandle)) {
      icon.style.fill = "black";
      iconElement.setAttribute("title", "Remove from Wishlist");
    } else {
      icon.style.fill = "white";
      iconElement.setAttribute("title", "Add to Wishlist");
    }

    // Attach event listener
    iconElement.addEventListener("click", function (e) {
      e.preventDefault();
      toggleWishlist(productHandle, iconElement);
    });
  });
  // Initialize wishlist icons on page load
  document.querySelectorAll(".wishlist-icon").forEach((iconElement) => {
    const productHandle = iconElement.dataset.productHandle;
    const wishlist = getWishlist();
    const icon = iconElement.querySelector("svg");

    if (wishlist.includes(productHandle)) {
      icon.style.fill = "black";
      iconElement.setAttribute("title", "Remove from Wishlist");
    } else {
      icon.style.fill = "white";
      iconElement.setAttribute("title", "Add to Wishlist");
    }

    // Attach event listener
    iconElement.addEventListener("click", function (e) {
      e.preventDefault();
      toggleWishlist(productHandle, iconElement);
    });
  });

  // Update wishlist count in navigation on page load
  updateWishlistCount();
});


